import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, withRouter, Switch } from 'react-router-dom';
import MainPage from './common/MainPage';
import Navbar from './common/Navbar';
import Footer from './common/Footer';
import PropertyPage from './common/Property';
import About from './common/About'
import PageNotFound from './common/PageNotFound'
import {data} from './const/data'

// import SingleArticle from './common/SingleArticle';
// import CreateArticle from './common/CreateArticle';
// import Login from './common/Login';
// import ContactUs from './common/ContactUs';
// import Signup from './common/Signup';



const Main = withRouter(( {location} ) => {

  
  return (
    <div>

      {
        location.pathname !== '/login' && location.pathname !== '/signup' &&  <Navbar info={data}/>
      } 
    

        <Switch>
          <Route exact path="/" render={(props) => <MainPage  {...props} info={data}/>} />
          <Route exact path="/imoveis/:slug" component={withRouter(PropertyPage)}/>
          <Route path="/about" component={About}/>
          <Route path="*" component={PageNotFound} />
          {/* <Route path="/login" component={Login} />
          <Route path="/signup" component={Signup} /> */}
          {/* <Route path="/article/:slug" component={SingleArticle} /> */}
          {/* <Route path="/articles/create" component={CreateArticle}/> */}
          {/* <Route path="/contact-us" component={ContactUs} /> */}
        </Switch>

     
    

    

      {
        location.pathname !== '/login' && location.pathname !== '/signup' && <Footer />
      }

 
  </div>
  );

}) 

ReactDOM.render(
  <BrowserRouter>

  <Main />
    
  </BrowserRouter>
  ,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js